const coord_size = 45;
export const Room_Images =[
    {
        id:0,
        name: "Lounge",
        url: "https://res.cloudinary.com/adebola19/image/upload/v1639417472/BOBZA/Rooms/New/TV_room_dupogc.jpg",
        areas: [
            { name: "painting", shape: "circle", href: "/products/painting", coords: [143, 198, coord_size], fillColor: "#f9a701", categories: "painters,photographers" },
          { name: "pot-plant", shape: "circle", href: "/products/pot-plant", coords: [61, 333, coord_size], fillColor: "#f9a701", categories: "nurseries,florists,gardeners" },
          { name: "couch", shape: "circle", href: "/products/couch", coords: [229, 342, 40], fillColor: "#f9a701", categories: "interior designers,architects" },
          { name: "book-shelf", shape: "circle", href: "/products/book-shelf", coords: [279, 188, coord_size], fillColor: "#f9a701", categories: "books" },
          //{ name: "tv", shape: "circle", href: "/products/tv", coords: [388, 240, coord_size], fillColor: "#f9a701" },
        ]

    },
    {
        id:1,
        name: "Kitchen",
        url: "https://res.cloudinary.com/adebola19/image/upload/v1637248473/BOBZA/Rooms/New/kitchen-01_p8jrlf.jpg",
        areas: [
          { name: "fridge", shape: "circle", href: "/products/fridge", coords: [349, 264, coord_size], fillColor: "#f9a701", categories: "non-perishable foods" },
          { name: "stove", shape: "circle", href: "/products/stove", coords: [113, 280, coord_size], fillColor: "#f9a701", categories: "catering comanies, evenets & decor" },
          { name: "oven", shape: "circle", href: "/products/oven", coords: [210, 288, coord_size], fillColor: "#f9a701", categories: "bakeries" },
          { name: "dining-table", shape: "circle", href: "/products/dining-table", coords: [256, 359, coord_size], fillColor: "#f9a701", categories: "resturant, pvt chefs" },
          { name: "drinks-cabinet", shape: "circle", href: "/products/drinks-cabinet", coords: [178, 159, coord_size], fillColor: "#f9a701", categories: "beverages" },
        ], 

    },
    {
        id:2,
        name: "Garage",
        url: "https://res.cloudinary.com/adebola19/image/upload/v1638608828/BOBZA/Rooms/New/GARAGE-01_vvye9i.jpg",
        areas: [
          { name: "car", shape: "circle", href: "/products/car", coords: [213, 270, coord_size], fillColor: "#f9a701", categories: "car hire,washing & detailing" },
          { name: "boxes", shape: "circle", href: "/products/boxes", coords: [289, 422, coord_size], fillColor: "#f9a701", categories: "moving service,courier" },
          { name: "tools", shape: "circle", href: "/products/tools", coords: [368, 170, coord_size], fillColor: "#f9a701", categories: "plumbers, electricians"},
          { name: "bucket", shape: "circle", href: "/products/bucket", coords: [398, 359, coord_size], fillColor: "#f9a701", categories: "cleaning products & services" },
        ],

    },
    {
        id:3,
        name: "Bedroom",
        url: "https://res.cloudinary.com/adebola19/image/upload/v1637248473/BOBZA/Rooms/New/bedroom-01_sdl8fh.jpg",
        areas: [
          { name: "wardrobe", shape: "circle", href: "/products/wardrobe", coords: [411, 290, coord_size], fillColor: "#f9a701", categories: "clothing,shoes" },
          { name: "bed", shape: "circle", href: "/products/bed", coords: [265, 320, coord_size], fillColor: "#f9a701",categories: "hotels,B&Bs" },
          { name: "accessories", shape: "circle", href: "/products/accessories", coords: [54, 324, coord_size], fillColor: "#f9a701", categories: "bags,watches,jewellery" },
          { name: "beauty-table", shape: "circle", href: "/products/beauty-table", coords: [169, 249, coord_size], fillColor: "#f9a701", categories: "hair,makeup,beauty" },
        ],

    },
    {
        id:4,
        name: "Bathroom",
        url: "https://res.cloudinary.com/adebola19/image/upload/v1637248473/BOBZA/Rooms/New/bathroom-01_xhb0xn.jpg",
        areas: [
            { name: "bathtub", shape: "circle", href: "/products/bathtub", coords: [236,260, coord_size], fillColor: "#f9a701", categories: "body products,skincare,masseuses,spas"  },
            { name: "medicine-cabinet", shape: "circle", href: "/products/medicine-cabinet",coords: [380,321, coord_size], fillColor: "#f9a701", categories: "doctors,psychologists,dentists" },
            { name: "candles", shape: "circle", href: "/products/candles",coords: [65,324,coord_size], fillColor: "#f9a701", categories: "candles,perfumes,scents"  },
        ],

    },
]